import {UserConsentApiDto} from "../../api/model/rest";

export default class UserConsentData {
	constructor(public readonly userConsentType: string) {}

	toJson(): UserConsentApiDto {
		return {userConsentType: this.userConsentType}
	}

	static fromJson(json: UserConsentApiDto): UserConsentData {
		return new UserConsentData(json.userConsentType);
	}

	copy(userConsentType = this.userConsentType) {
		return new UserConsentData(userConsentType)
	}
}

export enum UserConsentType {
	Crm = "CRM",
	Mobile = "MOBILE"
}